import React from 'react';
import {Layout, Menu, Button, Modal, message, Input, Tooltip} from 'antd';
import BeianIcon from "../../assets/img/beian-icon.png";
import './root.scss';

const {Header, Content, Footer, Sider} = Layout;
const {SubMenu, Item} = Menu;
const Block = React.Fragment;

class Root extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.screen.width < 500, // 是否是移动端
        };
    }

    componentDidMount() {
        const {match={}} = this.props;
        if (match.history) {
            window.historyInstance = match.history;
        }
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({
            isMobile: document.documentElement.clientWidth < 500,
        });
    }

    render() {
        const that = this;
        return (
            <Layout className="rootFrame">
                {/* top */}
                {/*<Header className="rootFrameTop"></Header>*/}
                {/*contentView */}
                <Content className="contentView">{that.props ? that.props.children : 'notChildPage'}</Content>

                {/* bottom */}
                <Footer className="rootFrameBottom">
                    <div className="bottomContent">
                        <div className="beianBox">
                            <span className="title">奇文网@2024</span>
                            <a href="https://beian.miit.gov.cn">黔ICP备2024039196号-1</a>
                        </div>
                        <div className="beianBox">
                            <img className="beianIcon" src={BeianIcon} alt=""/>
                            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51015602001143" rel="noreferrer" target="_blank">川公网安备51015602001143</a>
                        </div>
                    </div>
                </Footer>
            </Layout>
        );
    }
}

Root.propTypes = {};

export default Root;
